import {ValueObject} from '@s-ui/domain'

/**
 * https://schema.org/AggregateRating
 */
export class AggregateRatingStructuredDataSeoValueObject extends ValueObject {
  #bestRating = 5
  #ratingCount
  #ratingValue
  #type = 'AggregateRating'

  constructor({ratingCount, ratingValue}) {
    super()
    this.#ratingCount = ratingCount
    this.#ratingValue = ratingValue
  }

  static createFromPrimitives({ratingCount, ratingValue}) {
    return new AggregateRatingStructuredDataSeoValueObject({ratingCount, ratingValue})
  }

  get bestRating() {
    return this.#bestRating
  }

  get ratingCount() {
    return this.#ratingCount
  }

  get ratingValue() {
    return this.#ratingValue
  }

  get type() {
    return this.#type
  }

  get value() {
    return {
      '@type': this.#type,
      bestRating: this.#bestRating,
      ratingCount: this.#ratingCount,
      ratingValue: this.#ratingValue
    }
  }
}
